import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { CommunicationConstants } from 'src/app/core/constants/communication';
import { IResult } from 'src/app/core/interfaces/result';
import { environment } from 'src/environments/environment';
import { IRequestValidateDocument } from './file-upload.model';

const API_MAIN = environment.segurity + environment.host + environment.version + environment.typeService;

@Injectable()
export class FileUploadService {

  private urlValidateDocument : string = API_MAIN + "file-api/validate-document";

  constructor(
    private _http: HttpClient
  ){}



  validateDocument(request: IRequestValidateDocument) : Observable<any>{

    const resp = {
        "Succeeded": true,
        "Data": {
            "IsValid": true
        }
    }

    return of(resp);

    return this._http
      .post<IResult<number>>(this.urlValidateDocument, request)
      .pipe(
        map((res: IResult<number>) => {
          const [codigosCom, mensajesCom] = CommunicationConstants;
          if (res === null){
              throw new Error(`${codigosCom.ERRORSRV}||${mensajesCom.MSGDATAVACIOSRV}`);
          }
          if(!res.Succeeded){
              throw new Error(`${res.Message}`);
          }
          return res.Data;
        })
      );
	}

}
